import { Component, EventEmitter, Input, Output } from "@angular/core";
import { User } from "../../providers";

@Component({
  selector: "app-training-list",
  templateUrl: "./training-list.html",
})
export class TrainingListComponent {
  private _status: "pending" | "completed";
  @Input() set status(value: "pending" | "completed") {
    if (!!value) {
      this._status = value;
      this.trainings = [];
      this.page = 1;
      this._getData();
    }
  }
  @Output() trainingClick: EventEmitter<any> = new EventEmitter();
  page = 1;
  trainings: any = [];
  showBlankState = false;
  showInfiniteScroll = false;

  constructor(private _user: User) {}

  handleLoadMore(infiniteScrollEvent) {
    this.page += 1;
    this._getData(infiniteScrollEvent);
  }

  handleTrainingClick(trainingId) {
    this.trainingClick.emit(trainingId);
  }

  private _getData(infiniteScrollEvent?: any | null) {
    this._user
      .getTrainings(this._status, this.page)
      .subscribe((result: any) => {
        this.trainings = this.trainings.concat(result.data);
        this.showInfiniteScroll = result.pagination.hasNext;
        this.showBlankState = !result.data.length;
        if (!!infiniteScrollEvent) {
          infiniteScrollEvent.complete();
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/training-list/training-list.ts